// Tracks a team invitation the user is trying to accept, so they can be routed
// back to /join after signing in / creating an account (bypassing workspace creation).
export const PENDING_INVITE_KEY = "pinlayr_pending_invite";

export function getPendingInvite() {
  try { return localStorage.getItem(PENDING_INVITE_KEY); } catch (_e) { return null; }
}
export function setPendingInvite(token) {
  try { localStorage.setItem(PENDING_INVITE_KEY, token); } catch (_e) { /* ignore */ }
}
export function clearPendingInvite() {
  try { localStorage.removeItem(PENDING_INVITE_KEY); } catch (_e) { /* ignore */ }
}

// Where to send a user right after authenticating.
export function postAuthPath(payload) {
  const t = getPendingInvite();
  if (t) return `/join/${t}`;
  return payload?.has_workspace ? "/app" : "/workspace";
}
